module.exports = __webpack_public_path__ + "img/UHF-DVS-50.e218add1.webp";